export const insurancePoliciesQuestionId =
  'company_info.amount_of_insurance_policies';

// Insurance policy modal questions
export const insurancePolicyNameQuestionId =
  'company_info.insurance_policy_name';
export const insurancePolicyClosedAtDistributionQuestionId =
  'company_info.insurance_policy_closed_at_distribution';
export const insurancePolicyStatusQuestionId =
  'company_info.insurance_policy_status';
export const insurancePolicyCoveragesQuestionId =
  'company_info.insurance_policy_coverages';
export const insurancePolicyDocumentsQuestionId =
  'company_info.insurance_policy_documents';
